<template>
  <!-- 导览 -->
  <div class="guide-wrapper w-100">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form @keyup.enter.native="getTableList" class="com-search-box" inline :model="form" ref="form" label-width="70px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="关键词：">
              <el-input v-model="form.fileName" placeholder="请输入关键字"></el-input>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="6">
            <el-form-item label="文件分类：">
              <el-input v-model="form.type" placeholder="请输入文件分类"></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="resetForm()">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-upload v-if="from == 1" action="/singleMuseum/attach/upload" :data="configData" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
          <el-button class="el-primary-border" round >
            <svg-icon icon-class="add" />&nbsp;添加资料
          </el-button>
        </el-upload>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable"  v-loading="listLoading" stripe :data="tableData">
          <el-table-column  label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column  prop="attName" label="资料名称" show-overflow-tooltip></el-table-column>
          <!-- <el-table-column  prop="name" label="上传者" show-overflow-tooltip></el-table-column> -->
          <el-table-column  prop="attDate" label="上传日期" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{$common.formatDateString(scope.row.attDate, 'yyyy-MM-dd')}}</span>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column  fixed="right" label="操作" min-width="20%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="downLoad(scope.row)">下载</a>
              <a class="m-btn mr-10 m-danger" v-if="from == 1" @click="handleDelete(scope.row)">删除</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <!-- 新增 -->
    <!-- <div>
      <el-dialog @close="onCancel" :visible.sync="dialogVisible" :width="'400px'">
        <el-form ref="addForm" :model="addForm" inline :rules="rules">
          <el-form-item label="资料分类：" class="mb-30" prop="tableName">
            <el-input v-model="addForm.tableName" placeholder="请输入资料分类" />
          </el-form-item>

        </el-form>
      </el-dialog>
    </div> -->
  </div>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      form: {
        fileName: '',
        type: 'lnsb'
      },
      addForm: {},
      operation: 'add',
      configData: {
        tableName: "lnsb"
      },
      from: 0,
      rules: {
        tableName: [{ required: true, message: '资料分类不能为空', trigger: 'blur' }],
      },
      imgUrl: "",
      listLoading: true,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      tableData: [],
      dialogVisible: false
    }
  },
  methods: {
    // 项目列表
    getData() {
      this.listLoading = true
      this.$http
        .get('/attach/getFileList', {
          ...this.form,
          ...this.listQuery,
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            if (res.result && res.result.result) {
              this.tableData = res.result.result.records
              this.total = res.result.result.total
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },


    // 重置查询
    resetForm() {
      this.form = {
        name: '',
        type: 'lnsb'
      }
      this.listQuery.currentPage = 1
      this.getData()
    },

    // onCancel() {
    //   this.$refs['addForm'].resetFields()
    //   this.dialogVisible = false
    // },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.getData()
    },

    // 新增
    handleAdd() {
      this.operation = "add"
      this.dialogVisible = true
    },

    downLoad(item) {
      location.href = '/singleMuseum/attach/downloadFile?attachmentId=' + item.attId
    },

    // 删除
    handleDelete(obj) {
      this.$common.confirm(
        {
          title: '您正在删除资料，是否确认删除？',
          className: 'cus-confirm-375'
        },
        () => {
          this.$http
            .delete('/attach/deleteAttachment', {
              id: obj.attId
            })
            .then(res => {
              if (res.success) {
                this.$message.success('资料删除成功')
                this.getData()
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getData()
    },

    beforeAvatarUpload(file) {
      // if (!this.addForm.tableName) {
      //   this.$message.warning('请输入资料分类')
      //   return Promise.reject(false);
      // } else {
      //   this.configData.tableName = this.addForm.tableName
      // }
    },

    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('上传资料成功')
        // this.onCancel()
        this.getData()
      } else {
        this.$message.error(res.message)
      }
    },
  },
  created() {
    this.from = this.$route.query.type
    this.getData()
  }
}
</script>

<style lang="scss" scoped>
.upload-wrapper {
  color: $primary;
}
.guide-wrapper {
  /deep/ .el-form-item {
    .el-form-item__content {
      margin-left: 0 !important;
    }

    &.avatar-uploader-form {
      display: flex;
      flex-direction: column;
      /deep/ .el-form-item__content {
        margin-left: 0 !important;
      }

      .avatar-uploader {
        width: 50%;
        border: 1px dashed #8c939d;
        height: 120px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .el-upload {
          width: 100%;
        }
        .el-icon-plus {
          font-size: 20px;
        }

        .el-upload__text {
          line-height: 1;
        }
      }
    }
  }
}
</style>